module.exports = "<script type=\"text/html\" id=\"propertyeditor-custom\">\n    <!-- ko template: { name: \"propertyeditor-customcontent\", data: $data, afterRender: $data.koAfterRender } --><!-- /ko -->\n</script>\n<script type=\"text/html\" id=\"propertyeditor-customcontent\"><div></div></script>";


//////////////////
// WEBPACK FOOTER
// ./src/templates/propertyEditors/propertyeditor-custom.html
// module id = 114
// module chunks = 0